module.exports = __webpack_public_path__ + "img/thumbs_up_mobile.aab17d2f.png";